import React from 'react'

function Tab({ selected = false }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" style={{pointerEvents:"none"}}>
  <g data-name="Group 54644" transform="translate(-678 -12)">
    <g data-name="Rectangle Copy 67" transform="translate(678 12)" fill="#fff" stroke="#202020" strokeMiterlimit="10" strokeWidth="1">
      <rect width="14" height="16" rx="2" stroke={selected ? "#0072c6" : "#606060"} />
      <rect x="0.5" y="0.5" width="13" height="15" rx="1.5" fill="none" stroke={selected ? "#0072c6" : "#606060"} />
    </g>
    <path dataname="Line 3 Copy" d="M.5.5h13" transform="translate(678 24)" fill="none" stroke={selected ? "#0072c6" : "#606060"} strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1"/>
    <rect dataname="Rectangle Copy 68" width="1" height="1" rx="0.5" transform="translate(684.5 25.5)" stroke={selected ? "#0072c6" : "#606060"} />
  </g>
</svg>

    )
}

export default Tab
